import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]
  static values = { 
    jobStatus: String,
    isApprovalTeamMember: Boolean,
    requiresApproval: Boolean
  }

  connect() {
    this.setupFormSubmission()
  }

  setupFormSubmission() {
    this.formTarget.addEventListener('submit', (event) => {
      if (this.shouldShowApprovalWarning()) {
        event.preventDefault()
        this.showApprovalWarning(event)
      }
    })
  }

  shouldShowApprovalWarning() {
    // Zeige Warnung nur wenn:
    // 1. Job-Approval aktiviert ist
    // 2. User ist NICHT Mitglied des Freigabe-Teams
    // 3. Job ist bereits freigegeben (approved) oder wartet auf Freigabe (pending_approval)
    return this.requiresApprovalValue && 
           !this.isApprovalTeamMemberValue && 
           (this.jobStatusValue === 'approved' || this.jobStatusValue === 'pending_approval')
  }

  showApprovalWarning(event) {
    const message = this.getApprovalWarningMessage()
    
    if (confirm(message)) {
      // Formular normal absenden
      this.formTarget.submit()
    }
    // Wenn abgebrochen wird, bleibt das Formular offen
  }

  getApprovalWarningMessage() {
    if (this.jobStatusValue === 'approved') {
      return '⚠️ Achtung: Dieser Job ist bereits freigegeben. Nach dem Speichern wird eine erneute Freigabe durch das Freigabe-Team erforderlich sein. Möchten Sie fortfahren?'
    } else if (this.jobStatusValue === 'pending_approval') {
      return '⚠️ Achtung: Dieser Job wartet bereits auf Freigabe. Nach dem Speichern wird eine erneute Freigabe durch das Freigabe-Team erforderlich sein. Möchten Sie fortfahren?'
    }
    return '⚠️ Achtung: Nach dem Speichern wird eine Freigabe durch das Freigabe-Team erforderlich sein. Möchten Sie fortfahren?'
  }
}
